import {
  inOutMotion,
  inOutZoom,
  opacityMotion,
  slideUp,
} from "UI/motionStyles";

export const useAnimationStyles = ({
  direction,
  delayIn,
  delayOut,
  variant,
  snapHeight,
  quickExit,
}) => {
  const exitDelay = quickExit ? 0 : delayOut;
  const exitDuration = quickExit ? 0.15 : undefined;
  // TODO: Replace this with a new "slide" variant.
  if (direction) {
    return {
      initial: { y: direction === "top" ? -50 : 50, opacity: 0 },
      animate: {
        y: 0,
        opacity: 1,
        transition: { ...slideUp.transition, delay: delayIn },
      },
      exit: {
        y: direction === "top" ? -50 : 50,
        opacity: 0,
        transition: {
          delay: exitDelay,
          duration: exitDuration,
          ease: "easeOut",
        },
      },
      // Slide mode: no card-height collapse, spacer animates on its own.
      paddingTransition: { duration: 0.2 },
    };
  }

  switch (variant) {
    case "fade":
      return {
        ...inOutMotion,
        initial: {
          ...inOutMotion.initial,
          height: snapHeight ? "auto" : inOutMotion.initial.height,
        },
        exit: {
          ...inOutMotion.exit,
          transition: { delay: exitDelay, duration: exitDuration },
          height: snapHeight ? "auto" : inOutMotion.exit.height,
        },
        animate: {
          ...inOutMotion.animate,
          transition: { ...inOutMotion.transition, delay: delayIn },
        },
        paddingTransition: { delay: exitDelay, duration: exitDuration },
      };
    case "opacity":
      return {
        ...opacityMotion,
        exit: {
          ...opacityMotion.exit,
          transition: { delay: exitDelay, duration: exitDuration },
        },
        animate: { ...opacityMotion.animate, transition: { delay: delayIn } },
        // Opacity variant: no card-height collapse, spacer is independent.
        paddingTransition: { duration: 0.2 },
      };
    case "gentle":
      return {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0, transition: { delay: delayIn } },
        exit: {
          opacity: 0,
          y: -10,
          ...(quickExit && { height: 0, overflow: "hidden" }),
          transition: quickExit
            ? {
                opacity: { duration: 0.15, delay: exitDelay },
                y: { duration: 0.2, delay: exitDelay, ease: "easeOut" },
                height: { duration: 0.5, delay: 0.1, ease: [0.4, 0, 0.1, 1] },
              }
            : { delay: exitDelay, duration: exitDuration },
        },
        paddingTransition: quickExit
          ? { duration: 0.5, delay: 0.1, ease: [0.4, 0, 0.1, 1] }
          : { duration: 0.2 },
      };
    case "scale":
    default:
      return {
        ...inOutZoom,
        initial: {
          ...inOutZoom.initial,
          height: snapHeight ? "auto" : inOutZoom.initial.height,
        },
        exit: {
          ...inOutZoom.exit,
          transition: { delay: exitDelay, duration: exitDuration },
          height: snapHeight ? "auto" : inOutZoom.exit.height,
        },
        animate: {
          ...inOutZoom.animate,
          transition: { ...inOutZoom.transition, delay: delayIn },
        },
        paddingTransition: {
          ...inOutZoom.transition,
          delay: exitDelay,
          duration: exitDuration,
        },
      };
  }
};
